import FundTermsIcon from '@material-ui/icons/Work';
import FundTermsList from './FundTermsList';
import FundTermsEdit from './FundTermsEdit';
import FundTermsCreate from './FundTermsCreate';

export default {
  create: FundTermsCreate,
  edit: FundTermsEdit,
  list: FundTermsList,
  icon: FundTermsIcon
};
